import { DELETE_TASK, UPDATE_TASK } from 'bundles/apex/deals/show/store/tasks/actions';
import { filterTasksAndDates, getTasks } from 'bundles/apex/planner/helpers';
import { post, put } from 'helpers/api';
import { requestErrors } from 'helpers/api_errors';

export const SET_EDITING = 'SET_EDITING';
export function setEditing(editing) {
  return {
    type: SET_EDITING,
    editing
  };
}

export const SELECT_ALL = 'SELECT_ALL';
export function selectAll() {
  return (dispatch, getState) => {
    const state = getState();
    const selectableTasks = filterTasksAndDates(getTasks(state), state.fields, state.plannerFilters);
    dispatch({
      type: SELECT_ALL,
      allTaskIds: selectableTasks.map(task => task.record.id),
    });
  };
}

export const CLEAR_SELECTION = 'CLEAR_SELECTION';
export function clearSelection() {
  return { type: CLEAR_SELECTION };
}

export const TOGGLE_TASK_SELECTION = 'TOGGLE_TASK_SELECTION';
export function toggleTaskSelection(task) {
  return {
    type: TOGGLE_TASK_SELECTION,
    task,
  };
}

export function updateTasks(changes) {
  return async (dispatch, getState) => {
    const { plannerBulkActions: { selection }, paths } = getState();

    try {
      const tasks = await put(paths.bulkUpdateTasks, { task_ids: Object.keys(selection), ...changes });
      tasks.forEach(task => dispatch({ type: UPDATE_TASK, task }));
      dispatch(setEditing(false));
      dispatch(clearSelection());

      return tasks;
    } catch (error) {
      return { errors: requestErrors(error) };
    }
  };
}

export function deleteTasks() {
  return async (dispatch, getState) => {
    const { plannerBulkActions: { selection }, tasks, paths } = getState();

    try {
      await post(paths.bulkDeleteTasks, { task_ids: Object.keys(selection) });
    } catch (error) {
      return { errors: requestErrors(error) };
    }

    tasks.forEach(task => selection[task.id] && dispatch({ type: DELETE_TASK, task }));
    dispatch(setEditing(false));
    dispatch(clearSelection());

    return {};
  };
}

export const SET_ASSIGNEE = 'SET_ASSIGNEE';
export function setAssignee(assignee) {
  return {
    type: SET_ASSIGNEE,
    assignee
  };
}

export const SET_DUE_DATE = 'SET_DUE_DATE';
export function setDueDate(dueDate) {
  return {
    type: SET_DUE_DATE,
    dueDate
  };
}
